export default __webpack_public_path__ + "static/media/with-vector-file.1caa5974.png";